import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link , useParams} from 'react-router-dom';
import HeaderTablePage from '../components/HeaderTablePage';
import LoadingTable from '../components/LoadingTable';
import { verifyTokenExpire } from 'middleware/verifyToken';
import appConfig from 'config/appConfig';
import { verifyPermission } from 'helpers/permission';
import axios from 'axios';
import FacebookConfigEditForm from 'views/components/SocialMediaConfig/FacebookConfigEditForm';
import WhatsappConfigEditForm from 'views/components/SocialMediaConfig/WhatsappConfigEditForm';
import LinkedinConfigEditForm from 'views/components/SocialMediaConfig/LinkedinConfigEditForm';
import { ToastBottomEnd } from 'views/components/Toast';
import { toastErrorMessageWithParameterConfig, toastSuccessMessageWithParameterConfig } from 'config/toastConfig';
import { useTranslation } from 'react-i18next';

const SocialMediaConfigEditForm = (props) => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const {id} = useParams();
    
    const defaultError = {
        institution_id: [],
        fields: [],
        fields2: [],
        fields3: [],
        facebookError: "",
        whatsappError: "",
        linkedinError: "",
    };

    const defaultData = {
        institution_id: "",
        linkedin_configs: {},
        facebook_configs: {},
        whatsapp_configs: {},
    };

    const [loading, setLoading] = useState(false);
    const [loadingBlock, setLoadingBlock] = useState(false);
    const [error, setError] = useState(defaultError);
    const [institutionData, setInstitutionData] = useState(undefined);
    const [institutionId, setInstitutionId] = useState(null);
    const [data, setData] = useState(defaultData);
    const [nowData, setNowData] = useState(defaultData);
    const [fields, setFields] = useState([]);
    const [fields2, setFields2] = useState([]);
    const [fields3, setFields3] = useState([]);


    const addField = () => {
        const newField = { key: null, value: null };
        setFields([...fields, newField]);
        setError({ ...error, fields: { ...error.fields, [fields.length]: {key: null, value: null} } });
    };

    const addField2 = () => {
        const newField = { key: null, value: null };
        setFields2([...fields2, newField]);
        setError({ ...error, fields2: { ...error.fields2, [fields2.length]: {key: null, value: null} } });
    };

    const addField3 = () => {
        const newField = { key: null, value: null };
        setFields3([...fields3, newField]);
        setError({ ...error, fields3: { ...error.fields3, [fields3.length]: {key: null, value: null} } });
    };

    const removeField = (index) => {
        setFields(fields.filter((field, i) => i !== index));
        setError({ ...error, fields: Object.fromEntries(Object.entries(error.fields).filter(([key]) => key !== index.toString())) });
    };

    const removeField2 = (index) => {
        setFields2(fields2.filter((field, i) => i !== index));
        setError({ ...error, fields2: Object.fromEntries(Object.entries(error.fields2).filter(([key]) => key !== index.toString())) });
    };

    const removeField3 = (index) => {
        setFields3(fields3.filter((field, i) => i !== index));
        setError({ ...error, fields3: Object.fromEntries(Object.entries(error.fields3).filter(([key]) => key !== index.toString())) });
    };

    // END POINT
    const postSocialMediaEndpoint = `${appConfig.apiDomaine}/social-network/configs`;
    const getSocialMediaEndpoint = `${appConfig.apiDomaine}/social-network/configs`;

    const fetchData = async () => {
        if (!verifyTokenExpire()) return;

        try {
            setLoading(true);
            setLoadingBlock(true);
            const response = await axios.get(getSocialMediaEndpoint);
            
            const newData = response.data.find((config) => {
                
                if(config.id == id){
                    return {
                        institution_id: config.institution_id,
                        linkedin_configs: config.linkedin_configs,
                        facebook_configs: config.facebook_configs,
                        whatsapp_configs: config.whatsapp_configs,
                    }
                }
            });

            setData({
                institution_id: newData.institution_id,
                linkedin_configs: newData.linkedin_configs,
                facebook_configs: newData.facebook_configs,
                whatsapp_configs: newData.whatsapp_configs,
            });

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const updateSocialMediaConfig = async() => {
        axios
        .post(postSocialMediaEndpoint, nowData)
        .then((response) => {
            ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig(t("Configuration mis a jour avec succès")));
            fetchData();
            setLoading(false);
        })
        .catch((error) => {
            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(t("Erreur lors de la mise a jour de la configuration")));
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (data && data!==defaultData) {

            var linkedinConfigs = [];
            var facebookConfigs = [];
            var whatsappConfigs = [];

            if(data.facebook_configs!==null){
                Object.entries(data.facebook_configs).forEach(([key, value]) => {
                    facebookConfigs.push({
                        key: key,
                        value: value
                    });
                })
            }

            if(data.whatsapp_configs!==null){
                Object.entries(data.whatsapp_configs).forEach(([key, value]) => {
                    whatsappConfigs.push({
                        key: key,
                        value: value
                    });
                })
            }

            if(data.linkedin_configs!==null){
                Object.entries(data.linkedin_configs).forEach(([key, value]) => {
                    linkedinConfigs.push({
                        key: key,
                        value: value
                    });
                })
            }

            setFields(facebookConfigs);
            setFields2(whatsappConfigs);
            setFields3(linkedinConfigs);

            setInstitutionId(data.institution_id);
            setLoadingBlock(false);
        }
    }, [data]);

    useEffect(() => {
        if (nowData && nowData!==defaultData) {
            updateSocialMediaConfig()
        }
    },[nowData]);

    const onSubmit = async(e) => {
        e.preventDefault();
        setLoading(true);
        
        let hasError = false;
        let hasError2 = false;
        let hasError3 = false;

        fields.forEach((field) => {
            if (!field.key || !field.value) {
                hasError = true;
            }
        });

        fields2.forEach((field) => {
            if (!field.key || !field.value) {
                hasError2 = true;
            }
        });

        fields3.forEach((field) => {
            if (!field.key || !field.value) {
                hasError3 = true;
            }
        });

        if (hasError || hasError2 || hasError3) {
            if(hasError) setError({...error, facebookError: 'Veuillez renseigner toutes les clés pour la configuration Facebook' });
            if(hasError2) setError({...error, whatsappError: 'Veuillez renseigner toutes les valeurs pour la configuration Facebook' });
            if(hasError3) setError({...error, linkedinError: 'Veuillez renseigner toutes les clés et valeurs ajouter' });
            
            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(t("Veuillez renseigner toutes les clés et valeurs ajouter")));
            setLoading(false);
            return;
        } else {

            let facebookData = {};
            let whatsappData = {};
            let linkedinData = {};

            fields.forEach((field) => {
                facebookData[field.key] = field.value;
            });

            fields2.forEach((field) => {
                whatsappData[field.key] = field.value;
            });

            fields3.forEach((field) => {
                linkedinData[field.key] = field.value;
            });

            setError({...error, facebookError: '', whatsappError: '', linkedinError: ''});
            setNowData({ ...data, institution_id: institutionId, facebook_configs: facebookData, whatsapp_configs: whatsappData, linkedin_configs: linkedinData });
        }
    };


    return (
        <div 
            className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >

            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#icone" className="kt-subheader__breadcrumbs-home">
                                <i className="flaticon2-shelter" />
                            </a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <Link
                                to="/settings/social-medias"
                                className="kt-subheader__breadcrumbs-link cursor-pointer"
                                style={{ cursor: "text" }}
                            >
                                {t("Configurations réseaux sociaux ")}
                            </Link>
                        </div>
                        <div className="kt-subheader__breadcrumbs">
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a
                                href="#button"
                                onClick={(e) => e.preventDefault()}
                                className="kt-subheader__breadcrumbs-link"
                                style={{ cursor: "text" }}
                            >
                                {t("Modifier une configuration ")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                
                <div className="kt-portlet">
                    <HeaderTablePage
                        addPermission=""
                        title={t("Modifier cette configuration de réseaux sociaux")}
                    />

                    <div>

                        <div className="kt-portlet__body">
                            {
                                loadingBlock ? <LoadingTable /> :
                                institutionId ? (
                                    <div className='col-lg-12 col-md-12 col-sm-12'>

                                        <FacebookConfigEditForm
                                            fields={fields}
                                            addField={addField}
                                            removeField={removeField}
                                            setFields={setFields}
                                            error={error}
                                        />

                                        <WhatsappConfigEditForm 
                                            fields2={fields2}
                                            addField={addField2}
                                            removeField={removeField2}
                                            setFields2={setFields2}
                                            error={error}
                                        />

                                        <LinkedinConfigEditForm 
                                            fields3={fields3}
                                            addField={addField3}
                                            removeField={removeField3}
                                            setFields3={setFields3}
                                            error={error}
                                        />
                        
                                        <div className='form-group row d-flex justify-content-end'>
                                            {
                                                fields.length || fields2.length || fields3.length ? 
                                                    <button className='btn btn-primary' disabled={loading} onClick={onSubmit} >
                                                        {loading && (
                                                            <span className="spinner-border spinner-border-sm m-0"></span>
                                                        )}
                                                        {t("Enregistrer")}
                                                    </button>
                                                : null
                                            }
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        userPermissions: state.user.user.permissions,
        plan: state.plan.plan,
    };
}

export default connect(mapStateToProps)(SocialMediaConfigEditForm)